'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.driveShareDialog = function (navigatorShim, pageController, googleShim, gapiScriptLoader) {
	let currentId, shareClient;
	const showSettings = function (fileId) {
		if (!navigatorShim.hasWindowFlag('cookieCheck')) {
			pageController.dispatchEvent('cookies-blocked');
			return;
		}
		if (!shareClient) {
			shareClient = gapiScriptLoader.buildShareClient();
		}
		shareClient.setOAuthToken(googleShim.getToken());
		shareClient.setItemIds([fileId]);
		shareClient.showSettingsDialog();
	};
	pageController.addEventListener('fileLoaded', (fileId) => {
		currentId = fileId;
	});
	pageController.addEventListener('shareSettingsRequested', (fileId) => {
		showSettings(fileId);
	});
	return mmWidgets.each(this, () => {
		this.on('click', () => {
			showSettings(currentId);
		});
	});
};
